import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "address-types"
}

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import Address from "@/shared/model/Address";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";


interface Props {
  address?:Address
  isInvoice?: boolean
  isDelivery?: boolean
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'AddressCardComponent',
  props: {
    address: { default: undefined },
    isInvoice: { type: Boolean, default: false },
    isDelivery: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props
/*const _classCard = computed(()=>{
  let res = "sog-card"
  if(props.isSelected){
    res += " selected"
  }
  if(props.allowSelect){
    res += " allow-select"
  }
  return res

})*/


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(SogCard, { class: "sog-card" }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          (props.isInvoice || props.isDelivery)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.isInvoice)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 0,
                      icon: "mdi-receipt-text",
                      class: "address-type-icon",
                      title: "Rechnungsadresse"
                    }))
                  : _createCommentVNode("", true),
                (props.isDelivery)
                  ? (_openBlock(), _createBlock(_component_v_icon, {
                      key: 1,
                      icon: "mdi-truck-delivery",
                      class: "address-type-icon",
                      title: "Lieferadresse"
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(SogFlexColumn, null, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("span", null, [
                _createVNode(SogDataLabel, {
                  value: props.address?.fullName
                }, null, 8, ["value"])
              ], 512), [
                [_vShow, props.address?.fullName]
              ]),
              _withDirectives(_createElementVNode("span", null, [
                _createVNode(SogDataLabel, {
                  value: props.address?.line1
                }, null, 8, ["value"])
              ], 512), [
                [_vShow, props.address?.line1 && props.address?.line1!=='']
              ]),
              _createElementVNode("span", null, [
                _createVNode(SogDataLabel, {
                  value: props.address?.street
                }, null, 8, ["value"]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createVNode(SogDataLabel, {
                  value: props.address?.houseNumber
                }, null, 8, ["value"]),
                _createVNode(SogDataLabel, {
                  value: props.address?.houseNumberAddition
                }, null, 8, ["value"])
              ]),
              _createElementVNode("span", null, [
                _createVNode(SogDataLabel, {
                  value: props.address?.postalCode
                }, null, 8, ["value"]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createVNode(SogDataLabel, {
                  value: props.address?.city
                }, null, 8, ["value"])
              ]),
              _createVNode(SogDataLabel, {
                value: props.address?.countryName
              }, null, 8, ["value"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}
}

})